import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { getGridVariants } from '@web/store/page-structure/grids/grids.models';

@Component({
    selector: 'web-toolbar-grid',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './web-toolbar-grid.component.html',
    styleUrls: ['./web-toolbar-grid.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarGridComponent {
    @Output() public onClick: EventEmitter<number> = new EventEmitter<number>();

    private _variants: number[] = null;
    public get variantOptions(): number[] {
        if (!this._variants) {
            return (this._variants = Object.entries(getGridVariants())
                .filter(([_, i]) => !i.hidden)
                .map(([k]) => Number(k)));
        }

        return this._variants;
    }
}
